import { Component } from 'react';
import AMapLoader from '@amap/amap-jsapi-loader';

class  MapComponent extends Component{
  // 2.dom渲染成功后进行map对象的创建
  componentDidMount(){
    // window._AMapSecurityConfig = {
    //   securityJsCode: "fc0be9484409ac0d7b57ccda2a53061c",
    // };
    AMapLoader.load({
      key:"eb88e9e620412e844a8d043b3dbee9a7",                     // 申请好的Web端开发者Key，首次调用 load 时必填
      version:"2.0",              // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
      plugins:["AMap.Scale"],     //需要使用的的插件列表，如比例尺'AMap.Scale'，支持添加多个如：['...','...']
    }).then((AMap)=>{
        var position = new AMap.LngLat(113.520656,34.714132);
      var map = new AMap.Map("container",{ //设置地图容器id
        viewMode:"3D",         //是否为3D地图模式
        zoom:13,                //初始化地图级别
        center: position, //初始化地图中心点位置
        resizeEnable: true
      });

      var marker = new AMap.Marker({
        position: position,
        // 以 icon 的 [center bottom] 为原点
        offset: new AMap.Pixel(0, 0)
    });
    marker.setLabel({
        direction:'right',
        offset: new AMap.Pixel(10, 0),  //设置文本标注偏移量
        content: "<div class='info'>河南省郑州市二七区马寨镇工业路11号院6号楼2楼</div>", //设置文本标注内容
    });
    // 将 markers 添加到地图
    map.add(marker);
    }).catch(e=>{
      console.log(e);
    })
  }
  render(){
      // 1.初始化创建地图容器,div标签作为地图容器，同时为该div指定id属性；
      return (
        <div id="container" style={{ height: '500px' }} > 
        </div>
    );
  }
}
//导出地图组建类
export default MapComponent;